// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".return-top[data-v-4d3afb14]{align-items:center;display:flex;justify-content:center;margin-bottom:20px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
